import React from 'react';
import { Box } from './UI-CHAKRA/Box';
import { Text } from './UI-CHAKRA/Text';
import { Button } from './UI-CHAKRA/Button';
import { themeColors } from '../shared/theme/themeColors';
import { ReactComponent as IconClose } from '../assets/images/icons/mevo/ic-exit-rounded-purple.svg'

interface MobileDefaultBottomProps {
    title: string;
    subtitle?: string;
    confirmLabel?: string;
    onConfirm?: () => void;
    onClose?: () => void;
    isOpen?: boolean;
    isLoading?: boolean;
    isDisabled?: boolean;
}

export function MobileDefaultBottom({
    title,
    subtitle,
    confirmLabel = 'Confirmar',
    onConfirm,
    onClose,
    isOpen,
    isLoading = false,
    isDisabled = false,
}: MobileDefaultBottomProps) {
    return (
        <Box
            position="fixed"
            bottom={0}
            left={0}
            right={0}
            bg="white"
            padding={'19px 20px 30px 20px'}
            boxShadow="0px -2px 8px rgba(0, 0, 0, 0.08)"
            borderRadius={'20px 20px 0 0'}
            zIndex={10}
        >
            <Box width={'100%'} mb={'8px'} justifyItems={'flex-end'}>
                <IconClose onClick={onClose} />
            </Box>

            <Text fontSize={'16px'} fontWeight={700} color={'primary.main'} mb={subtitle ? '8px' : '24px'}>
                {title}
            </Text>

            {subtitle && (
                <Text fontSize={'12px'} fontWeight={600} color={'gray.800'} mb={'24px'}>
                    {subtitle}
                </Text>
            )}

            <Button
                mt={subtitle ? 0 : 4}
                w="100%"
                bg={themeColors.info.main}
                color="white"
                onClick={onConfirm}
                isLoading={isLoading}
                isDisabled={isDisabled}
            >
                {confirmLabel}
            </Button>
        </Box>
    );
}
